import protectedComponent from 'components/helpers/protectedComponent';

export default protectedComponent(() => import('./gas'));

